export default __webpack_public_path__ + "static/media/exploreIllustration6.60bda3f8.jpeg";